// This address points to a dummy ERC20 contract deployed on Ethereum Mainnet,
// Goerli, Kovan, Rinkeby and Ropsten. Replace it with your smart contracts.
const addresses = {
  anyRateOracle: "0x4E08A865F6e0Cb25398a09e5180097c090406D40",
  billingFactory: "0x9ebc2b2Df6CbB9a15eD69A7Db8b60E838AA7D094",
};

export default addresses;
